import { createContext, useReducer, useContext } from 'react';
import authReducer from '../reducers/authReducer';
import initialAuthState from '../data/initialAuthState';

const AuthStateContext = createContext(initialAuthState);
const AuthDispatchContext = createContext(null);

function AuthContextProvider({ children }) {
  const [state, dispatch] = useReducer(authReducer, initialAuthState);

  return (
    <AuthStateContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>
        {children}
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  );
}

export default AuthContextProvider;

export const useAuthStateContext = () => useContext(AuthStateContext);
export const useAuthDispatchContext = () => useContext(AuthDispatchContext);